<template>
  <AppForm :label="label">
    <v-layout wrap justify-start align-center align-content-center>
      <v-flex xs3 style="max-width:200px;">
        <v-menu
          v-model="startMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="240px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startTimePartDate"
              :disabled="disabled || disabledStart"
              v-on="on"
              prepend-icon="event"
              readonly
              class="pa-0 ma-0"
              hide-details
            />
          </template>
          <v-date-picker
            v-model="startTimePartDate"
            :day-format="date => new Date(date).getDate()"
            :min="ioStartDatePartDate"
            :max="ioEndDatePartDate"
            @input="startMenu = false"
            @change="onChange()"
            no-title
            scrollable
            locale="ja"
          />
        </v-menu>
      </v-flex>
      <v-flex xs2 style="max-width:200px;">
        <v-select
          v-model="startTimePartTime"
          :disabled="disabled || disabledStart"
          :items="hourListStart"
          @change="onChange()"
          class="pl-2"
          hide-details
        />
      </v-flex>
      <v-flex xs1 style="text-align: center;">〜</v-flex>
      <v-flex xs3 style="max-width:200px;">
        <v-menu
          v-model="endMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="240px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endTimePartDate"
              :disabled="disabled || disabledEnd"
              v-on="on"
              prepend-icon="event"
              readonly
              class="pa-0 ma-0"
              hide-details
            />
          </template>
          <v-date-picker
            v-model="endTimePartDate"
            :day-format="date => new Date(date).getDate()"
            :min="ioStartDatePartDate"
            :max="ioEndDatePartDate"
            @input="endMenu = false"
            @change="onChange()"
            no-title
            scrollable
            locale="ja"
          />
        </v-menu>
      </v-flex>
      <v-flex xs2 style="max-width:200px;">
        <v-select
          v-model="endTimePartTime"
          :disabled="disabled || disabledEnd"
          :items="hourListEnd"
          @change="onChange()"
          class="pl-2"
          hide-details
        />
      </v-flex>
    </v-layout>
  </AppForm>
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    label: {
      type: String,
      default: '表示期間',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledStart: {
      type: Boolean,
      default: false,
    },
    disabledEnd: {
      type: Boolean,
      default: false,
    },
    campaignBudget: {
      type: Object,
      default: () => {},
    },
    ioStartDate: {
      type: String,
      default: '',
    },
    ioEndDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // datepicker表示制御用
      startMenu: false,
      endMenu: false,
      hourListStart: [],
      hourListEnd: [],
    }
  },
  computed: {
    startTimePartDate: {
      get() {
        return dayjs(this.campaignBudget.startTime).format('YYYY-MM-DD')
      },
      set(date) {
        const startTime = dayjs(date + ' ' + this.startTimePartTime + ':00')
        const now = dayjs().startOf('hour')
        if (startTime.isBefore(now)) {
          this.campaignBudget.startTime = now.format('YYYY-MM-DD 00:00:00')
        } else {
          this.campaignBudget.startTime = startTime.format(
            'YYYY-MM-DD 00:00:00',
          )
        }
        this.campaignBudget.updatedTime = true
      },
    },
    startTimePartTime: {
      get() {
        return dayjs(this.campaignBudget.startTime).format('HH:mm')
      },
      set(time) {
        this.campaignBudget.startTime =
          this.startTimePartDate + ' ' + time + ':00'
        this.campaignBudget.updatedTime = true
      },
    },
    endTimePartDate: {
      get() {
        return dayjs(this.campaignBudget.endTime).format('YYYY-MM-DD')
      },
      set(date) {
        this.campaignBudget.endTime = `${date} 23:59:59`
        this.campaignBudget.updatedTime = true
      },
    },
    endTimePartTime: {
      get() {
        return dayjs(this.campaignBudget.endTime).format('HH:mm')
      },
      set(time) {
        this.campaignBudget.endTime = this.endTimePartDate + ' ' + time + ':59'
        this.campaignBudget.updatedTime = true
      },
    },
    ioStartDatePartDate() {
      return dayjs(this.ioStartDate).format('YYYY-MM-DD')
    },
    ioEndDatePartDate() {
      return dayjs(this.ioEndDate).format('YYYY-MM-DD')
    },
    ioStartDateHourNumber() {
      return Number(dayjs(this.ioStartDate).format('HH'))
    },
    ioEndDateHourNumber() {
      return Number(dayjs(this.ioEndDate).format('HH'))
    },
    isSameStartDateAndIoStartDate() {
      if (!dayjs(this.campaignBudget.startTime).isValid()) return undefined
      return this.campaignBudget.startTimePartDate === this.ioStartDatePartDate
    },
    isSameEndDateAndIoEndDate() {
      if (!dayjs(this.campaignBudget.endTime).isValid()) return undefined
      return this.campaignBudget.endTimePartDate === this.ioEndDatePartDate
    },
    startHourNumber() {
      return Number(this.startTimePartTime.substr(0, 2))
    },
    endHourNumber() {
      return Number(this.endTimePartTime.substr(0, 2))
    },
    isSameDate() {
      return this.startTimePartDate === this.endTimePartDate
    },
  },
  mounted() {
    this.initTimeList()
  },
  methods: {
    onChange() {
      this.$emit('change')
      this.initTimeList()
    },
    initTimeList() {
      const tempListStart = []
      const tempListEnd = []
      const endHourNumber = this.isSameDate ? this.endHourNumber : 24
      for (let i = 0; i < endHourNumber; i++) {
        tempListStart.push({
          text: this.zeroPadding(i) + ':00',
          value: this.zeroPadding(i) + ':00',
          disabled: this.checkIsDisabledHourStart(i),
        })
      }
      const startHourNumber = this.isSameDate ? this.startHourNumber + 1 : 0
      for (let i = startHourNumber; i <= 23; i++) {
        tempListEnd.push({
          text: this.zeroPadding(i) + ':59',
          value: this.zeroPadding(i) + ':59',
          disabled: this.checkIsDisabledHourEnd(i),
        })
      }
      this.hourListStart = tempListStart
      this.hourListEnd = tempListEnd
    },
    zeroPadding(num, length = 2) {
      return ('0' + num).slice(-length)
    },
    checkIsDisabledHourStart(index) {
      // 開始日が今日であれば、現在以前の時刻は指定できない
      return (
        (this.campaignBudget.isTodayStartDate && index <= dayjs().hour()) ||
        // 案件予算の開始・終了日の外の日付時刻は指定できない
        (this.isSameStartDateAndIoStartDate &&
          index < this.ioStartDateHourNumber)
      )
    },
    checkIsDisabledHourEnd(index) {
      // 終了日が今日であれば、現在以前の時刻は指定できない(59分はできる)
      return (
        (this.campaignBudget.isTodayEndDate && index < dayjs().hour()) ||
        // 案件予算の開始・終了日の外の日付時刻は指定できない
        (this.isSameEndDateAndIoEndDate && index > this.ioEndDateHourNumber)
      )
    },
  },
}
</script>
